import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbCloudflareAccountsQuery } from '../../DomainsApi';
import { useBreadcrumbSearchConsoleAccountsQuery } from '../../DomainsApi/SearchConsole';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';

const DynamicCloudflareAccountsByIdBreadcrumb: BreadcrumbComponentType<'cloudflareAccountId'> = ({ match }) => {
  const cloudflareAccountId = useMemo(() => match.params.cloudflareAccountId ?? '', [match.params.cloudflareAccountId]);

  const breadcrumbQuery = useBreadcrumbCloudflareAccountsQuery(cloudflareAccountId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicCloudflareAccountsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Акаунти</span>;
};

const DynamicSearchConsoleAccountsByIdBreadcrumb: BreadcrumbComponentType<'searchConsoleAccountId'> = ({ match }) => {
  const searchConsoleAccountId = useMemo(() => match.params.searchConsoleAccountId ?? '', [match.params.searchConsoleAccountId]);

  const breadcrumbQuery = useBreadcrumbSearchConsoleAccountsQuery(searchConsoleAccountId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicSearchConsoleAccountsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Акаунти</span>;
};

const DynamicCloudflareBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Cloudflare</span>;
};

const DynamicSearchConsoleBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Search Console</span>;
};

const DynamicSearchConsoleCredsBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Облікові дані</span>;
};

const DynamicSearchConsoleOAuth2Breadcrumb: BreadcrumbComponentType = () => {
  return <span>OAuth2</span>;
};

const DynamicDomainsApiListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>API доменів</span>;
};

const CloudflareAccountsBreadcrumb = {
  DynamicCloudflareAccountsByIdBreadcrumb,
  DynamicCloudflareAccountsListBreadcrumb
};

const SearchConsoleAccountsBreadcrumb = {
  DynamicSearchConsoleAccountsByIdBreadcrumb,
  DynamicSearchConsoleAccountsListBreadcrumb,
  DynamicSearchConsoleCredsBreadcrumb,
  DynamicSearchConsoleOAuth2Breadcrumb,
};

export const DynamicDomainsApiBreadcrumb = {
  DynamicCloudflareBreadcrumb,
  CloudflareAccountsBreadcrumb,
  DynamicSearchConsoleBreadcrumb,
  SearchConsoleAccountsBreadcrumb,
  DynamicDomainsApiListBreadcrumb
};
